'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setErrorCallback = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _clipper = require('@doodle3d/clipper-lib/clipper');

var _clipper2 = _interopRequireDefault(_clipper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var errorCallback = void 0;
var setErrorCallback = exports.setErrorCallback = function setErrorCallback(callback) {
  errorCallback = callback;
};
_clipper2.default.Error = function (message) {
  if (errorCallback) errorCallback(message);
};

var CLIPPER = new _clipper2.default.Clipper();
var CLIPPER_OFFSET = new _clipper2.default.ClipperOffset();

var Shape = function () {
  function Shape() {
    var paths = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var closed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var capitalConversion = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var integerConversion = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var removeDuplicates = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

    _classCallCheck(this, Shape);

    this.paths = paths;
    if (capitalConversion) this.paths = this.paths.map(mapLowerToCapital);
    if (integerConversion) this.paths = this.paths.map(mapToRound);
    if (removeDuplicates) this.paths = this.paths.map(filterPathsDuplicates);
    this.closed = closed;
  }

  _createClass(Shape, [{
    key: '_clip',
    value: function _clip(type) {
      var solution = new _clipper2.default.PolyTree();

      CLIPPER.Clear();
      CLIPPER.AddPaths(this.paths, _clipper2.default.PolyType.ptSubject, this.closed);

      for (var _len = arguments.length, clipShapes = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        clipShapes[_key - 1] = arguments[_key];
      }

      for (var i = 0; i < clipShapes.length; i++) {
        var clipShape = clipShapes[i];
        CLIPPER.AddPaths(clipShape.paths, _clipper2.default.PolyType.ptClip, clipShape.closed);
      }
      CLIPPER.Execute(type, solution);

      var newShape = _clipper2.default.Clipper.PolyTreeToPaths(solution);
      return new Shape(newShape, this.closed);
    }
  }, {
    key: 'union',
    value: function union() {
      for (var _len2 = arguments.length, clipShapes = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        clipShapes[_key2] = arguments[_key2];
      }

      return this._clip.apply(this, [_clipper2.default.ClipType.ctUnion].concat(clipShapes));
    }
  }, {
    key: 'difference',
    value: function difference() {
      for (var _len3 = arguments.length, clipShapes = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        clipShapes[_key3] = arguments[_key3];
      }

      return this._clip.apply(this, [_clipper2.default.ClipType.ctDifference].concat(clipShapes));
    }
  }, {
    key: 'intersect',
    value: function intersect() {
      for (var _len4 = arguments.length, clipShapes = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        clipShapes[_key4] = arguments[_key4];
      }

      return this._clip.apply(this, [_clipper2.default.ClipType.ctIntersection].concat(clipShapes));
    }
  }, {
    key: 'xor',
    value: function xor() {
      for (var _len5 = arguments.length, clipShapes = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        clipShapes[_key5] = arguments[_key5];
      }

      return this._clip.apply(this, [_clipper2.default.ClipType.ctXor].concat(clipShapes));
    }
  }, {
    key: 'offset',
    value: function offset(_offset) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _options$jointType = options.jointType,
          jointType = _options$jointType === undefined ? 'jtSquare' : _options$jointType,
          _options$endType = options.endType,
          endType = _options$endType === undefined ? 'etClosedPolygon' : _options$endType,
          _options$miterLimit = options.miterLimit,
          miterLimit = _options$miterLimit === undefined ? 2.0 : _options$miterLimit,
          _options$roundPrecisi = options.roundPrecision,
          roundPrecision = _options$roundPrecisi === undefined ? 0.25 : _options$roundPrecisi;


      CLIPPER_OFFSET.Clear();
      CLIPPER_OFFSET.ArcTolerance = roundPrecision;
      CLIPPER_OFFSET.MiterLimit = miterLimit;

      var offsetPaths = new _clipper2.default.Paths();
      CLIPPER_OFFSET.AddPaths(this.paths, _clipper2.default.JoinType[jointType], _clipper2.default.EndType[endType]);
      CLIPPER_OFFSET.Execute(offsetPaths, _offset);

      return new Shape(offsetPaths, true);
    }
  }, {
    key: 'scaleUp',
    value: function scaleUp(factor) {
      _clipper2.default.JS.ScaleUpPaths(this.paths, factor);

      return this;
    }
  }, {
    key: 'scaleDown',
    value: function scaleDown(factor) {
      _clipper2.default.JS.ScaleDownPaths(this.paths, factor);

      return this;
    }
  }, {
    key: 'firstPoint',
    value: function firstPoint() {
      var toLower = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.paths.length === 0) {
        return;
      }

      var firstPath = this.paths[0];
      var firstPoint = firstPath[0];
      if (toLower) {
        return vectorToLower(firstPoint);
      } else {
        return firstPoint;
      }
    }
  }, {
    key: 'lastPoint',
    value: function lastPoint() {
      var toLower = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.paths.length === 0) {
        return;
      }

      var lastPath = this.paths[this.paths.length - 1];
      var lastPoint = this.closed ? lastPath[0] : lastPath[lastPath.length - 1];
      if (toLower) {
        return vectorToLower(lastPoint);
      } else {
        return lastPoint;
      }
    }
  }, {
    key: 'areas',
    value: function areas() {
      var _this = this;

      var areas = this.paths.map(function (path, i) {
        return _this.area(i);
      });
      return areas;
    }
  }, {
    key: 'area',
    value: function area(index) {
      var path = this.paths[index];
      var area = _clipper2.default.Clipper.Area(path);
      return area;
    }
  }, {
    key: 'totalArea',
    value: function totalArea() {
      return this.areas().reduce(function (totalArea, area) {
        return totalArea + area;
      }, 0);
    }
  }, {
    key: 'perimeter',
    value: function perimeter(index) {
      var path = this.paths[index];
      var perimeter = _clipper2.default.JS.PerimeterOfPath(path, this.closed, 1);
      return perimeter;
    }
  }, {
    key: 'perimeters',
    value: function perimeters() {
      var _this2 = this;

      return this.paths.map(function (path) {
        return _clipper2.default.JS.PerimeterOfPath(path, _this2.closed, 1);
      });
    }
  }, {
    key: 'totalPerimeter',
    value: function totalPerimeter() {
      var perimeter = _clipper2.default.JS.PerimeterOfPaths(this.paths, this.closed);
      return perimeter;
    }
  }, {
    key: 'reverse',
    value: function reverse() {
      _clipper2.default.Clipper.ReversePaths(this.paths);

      return this;
    }
  }, {
    key: 'thresholdArea',
    value: function thresholdArea(minArea) {
      var _arr = [].concat(_toConsumableArray(this.paths));

      for (var _i = 0; _i < _arr.length; _i++) {
        var path = _arr[_i];
        var area = Math.abs(_clipper2.default.Clipper.Area(path));

        if (area < minArea) {
          var index = this.paths.indexOf(path);
          this.paths.splice(index, 1);
        }
      }
      return this;
    }
  }, {
    key: 'join',
    value: function join(shape) {
      var _paths;

      (_paths = this.paths).splice.apply(_paths, [this.paths.length, 0].concat(_toConsumableArray(shape.paths)));

      return this;
    }
  }, {
    key: 'clone',
    value: function clone() {
      return new Shape(_clipper2.default.JS.Clone(this.paths), this.closed);
    }
  }, {
    key: 'shapeBounds',
    value: function shapeBounds() {
      return _clipper2.default.JS.BoundsOfPaths(this.paths);
    }
  }, {
    key: 'pathBounds',
    value: function pathBounds(index) {
      var path = this.paths[index];

      return _clipper2.default.JS.BoundsOfPath(path);
    }
  }, {
    key: 'clean',
    value: function clean(cleanDelta) {
      return new Shape(_clipper2.default.Clipper.CleanPolygons(this.paths, cleanDelta), this.closed);
    }
  }, {
    key: 'orientation',
    value: function orientation(index) {
      var path = this.paths[index];
      return _clipper2.default.Clipper.Orientation(path);
    }
  }, {
    key: 'pointInShape',
    value: function pointInShape(point) {
      var capitalConversion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var integerConversion = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (capitalConversion) point = vectorToCapital(point);
      if (integerConversion) point = roundVector(point);
      for (var i = 0; i < this.paths.length; i++) {
        var pointInPath = this.pointInPath(i, point);
        var orientation = this.orientation(i);

        if (!pointInPath && orientation || pointInPath && !orientation) {
          return false;
        }
      }

      return true;
    }
  }, {
    key: 'pointInPath',
    value: function pointInPath(index, point) {
      var capitalConversion = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var integerConversion = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      if (capitalConversion) point = vectorToCapital(point);
      if (integerConversion) point = roundVector(point);
      var path = this.paths[index];
      var intPoint = { X: Math.round(point.X), Y: Math.round(point.Y) };

      return _clipper2.default.Clipper.PointInPolygon(intPoint, path) > 0;
    }
  }, {
    key: 'fixOrientation',
    value: function fixOrientation() {
      if (!this.closed) {
        return this;
      }

      if (this.totalArea() < 0) {
        this.reverse();
      }

      return this;
    }
  }, {
    key: 'simplify',
    value: function simplify(fillType) {
      if (this.closed) {
        var shape = _clipper2.default.Clipper.SimplifyPolygons(this.paths, _clipper2.default.PolyFillType[fillType]);
        return new Shape(shape, true);
      } else {
        return this;
      }
    }
  }, {
    key: 'separateShapes',
    value: function separateShapes() {
      var shapes = [];

      if (!this.closed) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = this.paths[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var path = _step.value;

            shapes.push(new Shape([path], false));
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      } else {
        var areas = new WeakMap();
        var outlines = [];
        var holes = [];

        for (var i = 0; i < this.paths.length; i++) {
          var _path = this.paths[i];
          var orientation = this.orientation(i);

          if (orientation) {
            var area = this.area(i);
            areas.set(_path, area);
            outlines.push(_path);
          } else {
            holes.push(_path);
          }
        }

        outlines.sort(function (a, b) {
          return areas.get(a) - areas.get(b);
        });

        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = outlines[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var outline = _step2.value;

            var shape = [outline];

            var index = this.paths.indexOf(outline);

            var _arr2 = [].concat(holes);

            for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
              var hole = _arr2[_i2];
              var pointInHole = this.pointInPath(index, hole[0]);
              if (pointInHole) {
                shape.push(hole);

                var _index = holes.indexOf(hole);
                holes.splice(_index, 1);
              }
            }

            shapes.push(new Shape(shape, true));
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }

      return shapes;
    }
  }, {
    key: 'round',
    value: function round() {
      return new Shape(this.paths.map(mapToRound), this.closed);
    }
  }, {
    key: 'removeDuplicates',
    value: function removeDuplicates() {
      return new Shape(this.paths.map(filterPathsDuplicates), this.closed);
    }
  }, {
    key: 'mapToLower',
    value: function mapToLower() {
      return this.paths.map(mapCapitalToLower);
    }
  }]);

  return Shape;
}();

exports.default = Shape;


function mapCapitalToLower(path) {
  return path.map(vectorToLower);
}

function vectorToLower(_ref) {
  var X = _ref.X,
      Y = _ref.Y;

  return { x: X, y: Y };
}

function mapLowerToCapital(path) {
  return path.map(vectorToCapital);
}

function vectorToCapital(_ref2) {
  var x = _ref2.x,
      y = _ref2.y;

  return { X: x, Y: y };
}

function mapToRound(path) {
  return path.map(roundVector);
}

function roundVector(_ref3) {
  var X = _ref3.X,
      Y = _ref3.Y;

  return { X: Math.round(X), Y: Math.round(Y) };
}

function filterPathsDuplicates(path) {
  return path.filter(filterPathDuplicates);
}

function filterPathDuplicates(point, i, array) {
  if (i === 0) return true;

  var prevPoint = array[i - 1];
  return !(point.X === prevPoint.X && point.Y === prevPoint.Y);
}
//# sourceMappingURL=index.js.map